export const styles = {
  container: {
    flex: 1,
    paddingTop: 0,
    marginTop: 0,
  },
  item: {
    paddingTop: 15,
    paddingLeft: 5,
    fontSize: 12,
    height: 160,
    color: 'black',
    width: 80,
  },
  tinyLogo: {
    marginTop: 2,
    width: 22,
    height: 22,
  },
  scroll: {
    height: '100%',
    display: 'flex',
    position: 'relative',
    backgroundColor: 'black',
    // marginTop,
    width: '100%',
  },
  icon: {
    paddingLeft: 10,
  },
};
export const textAccentColor = '#b4c0d1';
